"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormHeading = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const Css_1 = require("../Css");
function FormHeading(props) {
    const { title, xss, isFirst = false, ...others } = props;
    return ((0, jsx_runtime_1.jsx)("h3", { css: {
            ...Css_1.Css.baseMd.$,
            // Add space before the heading, but only if it's not first.
            ...(!isFirst && Css_1.Css.mt4.$),
            ...xss,
        }, ...others, children: title }));
}
exports.FormHeading = FormHeading;
// https://github.com/gaearon/react-hot-loader/issues/304#issuecomment-456569720
FormHeading.isFormHeading = true;
